
export enum AccountSpecificColors {
  Sales = '#4F5A9F',
  Marketing = '#008989',
  SiteEngagements = '#C4CBCF',
  IntentSurge = '#EB5488',
};
